import React from 'react'
import "./ThreePoint.css"
const ThreePoint = () => {
  return (
    <div className="typing-indicator">
  <span></span>
  <span></span>
  <span></span>
</div>
  )
}

export default ThreePoint